<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BrowserError
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/09 | 富士通株式会社         | 新規作成
//================================================================================
-->
<template>
	<main class="main">
		<div class="contents__main">
			<table border=0 align=center>
				<tr>
					<th valign=top>
						<font-awesome-icon icon="exclamation-triangle" class="exclamation-triangle" />
					</th>
					<td>
					</td>
				</tr>
			</table>
			<table border=0 align=center>
				<tr>
					<td valign=top>
						<br>
						<div class="contents__div--lineheight">
							<div>
								<label class="contents__label--error">ご利用の端末は、本システムの動作条件を満たしておりません。</label><br />
							</div>
						</div>
						<br />
						<span>&nbsp;</span>
					</td>
				</tr>
			</table>
			<table border="1" align=center class="contents__table--width table-border">
				<tr>
					<td style="contents__frame">
						<div class="contents__subject--section">
							<label class="contents__subject">
								本システムは、以下のいずれかの条件を満たしている必要があります。
							</label>
						</div>
						<div class="contents__subject--section">
							<div class="contents__subject--div div_row">
								<div class="contents__subject--div_mark">
									<b><p class="contents__subject contents__subject--multiple">
										Windows ：
									</p></b>
									<p class="contents__subject contents__subject--multiple contents__p--width">
										Google Chrome、Microsoft Edge（Chromium版）
									</p>
								</div>
							</div>
							<div v-if="form.userRole != ROLE_TYPE.TOKYOTO_STAFF" class="contents__subject--div div_row">
								<div class="contents__subject--div_mark">
									<b><p class="contents__subject contents__subject--multiple">
										Mac OS ：
									</p></b>
									<p class="contents__subject contents__subject--multiple contents__p--width">
										Safari、Google Chrome
									</p>
								</div>
							</div>
							<div v-if="form.userRole != ROLE_TYPE.TOKYOTO_STAFF" class="contents__subject--div div_row">
								<div class="contents__subject--div_mark">
									<b><p class="contents__subject contents__subject--multiple">
										Android ：
									</p></b>
									<p class="contents__subject contents__subject--multiple contents__p--width">
										Chrome for Android
									</p>
								</div>
							</div>
							<div v-if="form.userRole != ROLE_TYPE.TOKYOTO_STAFF" class="contents__subject--div div_row">
								<div class="contents__subject--div_mark">
									<b><p class="contents__subject contents__subject--multiple">
										iOS ：
									</p></b>
									<p class="contents__subject contents__subject--multiple contents__p--width">
										Safari
									</p>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</table>
			<table class="contents__table--width" align="center" id="contents__userEnv">
				<tbody>
					<tr>
						<td>
							<div class="contents__subject--section">
								<label class="contents__subject"> お使いのブラウザは「{{form.txBrowsertype}}」です。 </label>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</main>
</template>

<script>

import { co_getBrowser, co_getOperationBrowserError } from '@/common/browserUtility.js'; 

import { STORE_USER_GET_INFO } from '@/const/store.js';
import { ROLE_TYPE } from '@/const/const.js';

export default {
	data: function () {
		return {
			form: {
				userRole: '',
				txOstype: '',
				txBrowsertype: '',
			},
			ROLE_TYPE: ROLE_TYPE,
		};
	},
	created: async function() {

		let userInfo = this.$store.getters[STORE_USER_GET_INFO];
		let role = "";
		if (userInfo.role != null) {
			role = userInfo.role;
		}
		this.form.userRole = role;

		// ブラウザ設定
		let os = await co_getOperationBrowserError();
		let osInfo = os.split(',');
		this.form.txOstype = osInfo[0] + ' ' + osInfo[1];	// OSの種類 + OSのバージョン OSは表示しない
		this.form.txBrowsertype = co_getBrowser();			// ブラウザの種類
	},
};
</script>

<style scoped>
.exclamation-triangle {
	color: #b30000;
	font-size: 54px;
}

.contents__label--error {
	color: #b30000;
}

.contents__subject--section {
	margin-top: 1%;
	margin-left: 3px;
}

.contents__subject {
	color: #262626;
}

.table-border {
	border: 1px solid #666;
}

.contents__frame {
	width: 87%;
	border: none;
}

#contents__userEnv td {
	text-align: right;
}

#contents__userEnv label {
	font-size: 80%;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__label--error {
		font-size: 16px;
	}
	.contents__div--lineheight {
		line-height: 2em;
	}
	.contents__table--width {
		width: 90%;
	}
	.contents__subject--div_mark {
		width: 100%;
	}
	.contents__subject {
		font-size: 16px;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.exclamation-triangle {
		font-size: 64px;
		/* text-align: center; */
	}
	.contents__label--error {
		font-size: 18px;
	}
	.contents__div--margintop {
		margin-top: 11px;
	}
	.contents__table--width {
		width: 97%;
	}
	.contents__subject--div_mark {
		width: 69%;
	}
	.contents__subject {
		font-size: 18px;
		display: block;
	}
	.contents__p--width {
		width: 134%;
		margin-top: -5%;
	}

	#contents__userEnv td {
		text-align: left;
	}
}

</style>